export default "__VITE_ASSET__CqDXCWpj__"